import { string } from 'yup';
import en from './en';

export interface ILocalizationKeys {
	welcome: string;
	youAlreadyHaveAnAccount: string;
	login: string;
	wouldYouLikeToCreateAnAccount: string;
	register: string;
	orSimplyPlayWithoutRegistration: string;
	youCanRegisterAtAnyTimeLater: string;
	playInstantly: string;
	emailValidation: string;
	passwordValidation: string;
	email: string;
	password: string;
	forgotPassword: string;
	continueWithGoogle: string;
	or: string;
	newAccount: string;
	continueWithEmail: string;
	registerWithEmail: string;
	repeatPassword: string;
	pleaseFillOutTheFieldsToRegister: string;
	passwordNotMatch: string;
	confirmPassword: string;
	createAnAccount: string;
	submit: string;
	deleteAccount: string;
	crossword: string;
	gridPuzzle: string;
	sudoku: string;
	wordSearch: string;
	dailyPuzzle: string;
	easyPuzzle: string;
	enterTheCodeHere: string;
	redeemPromoCode: string;
	redeem: string;
	promoCodeValidation: string;
	starterPackage: string;
	bestSellingOffer: string;
	saveFoxOffer: string;
	joker: string;
	freeHints: string;
	allThreeHoursHints: string;
	collect: string;
	yes: string;
	deleteAccountTitle: string;
	continueWithApple: string;
	timeSoFar: string;
	jokerAvailable: string;
	jokerDescription: string;
	backToLobby: string;
	start: string;
	intermediatePuzzles: string;
	hardPuzzles: string;
	proPuzzles: string;
	fullPage: string;
	doublePage: string;
	picturePuzzle: string;
	showMoreLevels: string;
	showLessLevels: string;
	doYouLikeRateFuchs: string;
	rateNow: string;
	thankYouForYourFeedback: string;
	gameOver: string;
	youMadeMistakesAndEndedTheGame: string;
	secondChance: string;
	restart: string;
	timeRequired: string;
	mistake: string;
	solved: string;
	done: string;
	thePuzzle: string;
	isComplete: string;
	help: string;
	currentBalance: string;
	sound: string;
	logout: string;
	feedback: string;
	language: string;
	smallCrosswordChest: string;
	mediumCrosswordChest: string;
	bigCrosswordChest: string;
	hugeCrosswordChest: string;
	smallCrosswordDescription: string;
	mediumCrosswordDescription: string;
	bigCrosswordDescription: string;
	hugeCrosswordDescription: string;
	smallGridPuzzleChest: string;
	mediumGridPuzzleChest: string;
	bigGridPuzzleChest: string;
	smallGridPuzzleDescription: string;
	mediumGridPuzzleDescription: string;
	bigGridPuzzleDescription: string;
	smallSudokuChest: string;
	mediumSudokuChest: string;
	bigSudokuChest: string;
	smallSudokuDescription: string;
	mediumSudokuDescription: string;
	bigSudokuDescription: string;
	smallWordSearchChest: string;
	mediumWordSearchChest: string;
	bigWordSearchChest: string;
	smallWordSearchDescription: string;
	mediumWordSearchDescription: string;
	bigWordSearchDescription: string;
	note: string;
	chestDescription: string;
	showMore: string;
	showLess: string;
	chooseYourAvatar: string;
	userValidation: string;
	feedbackFormValidation: string;
	whatCanWeImprove: string;
	youOpinionIsImportantToUs: string;
	gameIsUpdated: string;
	gameLobbyDescription: string;
	swipeLeftOrRightToSelectCrosswordOrSudokuPuzzle: string;
	hintButtonDescription: string;
	helpSettingDescription: string;
	unlockNow: string;
	purchaseCost: string;
	cancel: string;
	okay: string;
	requiredPurchasePuzzle: string;
	goToShop: string;
	new: string;
	size: string;
	totalWords: string;
	wordsCorrect: string;
	dataProtection: string;
	imprint: string;
	justForFun: string;
	allRightReserved: string;
	loginTitle: string;
	youAreNotRegisterSoPleaseRegisterFirst: string;
	invalidLoginCredentials: string;
	passwordDescription: string;
	rememberMe: string;
	youAreAlreadyRegister: string;
	registerViaEMail: string;
	sendTheEmailSuccessfully: string;
	userIsNotExists: string;
	reload: string;
	partnerShip: string;
	save: string;
	usernameUpdatedSuccessfully: string;
	agb: string;
	feedbackIsSendedSuccessfully: string;
	userAvatarIsUpdatedSuccessfully: string;
	jokersAreSuccessfullySended: string;
	successfullyPurchase: string;
}
const localizationConstants = {} as ILocalizationKeys;

for (const key in en) {
	localizationConstants[key as typeOf] = key;
}

export type typeOf = 'welcome';

export default localizationConstants;
